export default "<video controls>\n  <source [src]=\"src\" type=\"video/mp4\">\n</video>"